import request from '../../../../../shared/lib/request';
import { API } from '../../../../../shared/constants';


const getProfessione = () => request(
  {
    url: API.PROFESSIONE,
    method: 'GET',
  });

const getProfessioneOptions = () => getProfessione().then(
    (res) => res._embedded.professione.map((obj)=>{ return {value: obj.id, label: obj.nome }}) // eslint-disable-line
  ).then((data) => ({ options: data }));


const OccupazioneService = {
  getProfessione,
  getProfessioneOptions,
};

export default OccupazioneService;



// WEBPACK FOOTER //
// ./app/shared/services/api/anagrafica/professione/index.js